<template>
<div>
  <ErrorDetailsModal v-if="errorsDetailsModalData" :lang="lang" :errorsDetailsModalData="errorsDetailsModalData" @errorDetailsModalClose="errorDetailsModalClose"></ErrorDetailsModal>
  <div v-if="restaurants.length > 0" id='restaurantsFilter'>
    <h4><strong> {{$options.filters.translate('Select restaurants', lang)}}: </strong></h4>
    <form class="form-inline">
      <div class="checkbox" v-for="restaurant in restaurants" :key="restaurant.id">
        <label>
          <input type="checkbox" :id="restaurant" :value="restaurant" v-model="checkedRestaurants"> {{restaurant}}
        </label>
      </div>
    </form>
    <br>
    <button v-if="checkedRestaurants.length > 0" class="btn btn-warning" @click="uncheck()">{{$options.filters.translate('Deselect all', lang)}}</button>
  </div>
    <hr />
  <form>
    <div class="form-group">
    </div>
    <div class="form-group">
      <label for="dateFrom">{{$options.filters.translate('From', lang)}}:</label>
      <date-picker v-model="dateFrom" :config="pickerConfig"></date-picker>
    </div>
    <div class="form-group">
      <label for="dateTo">{{$options.filters.translate('To', lang)}}:</label>
      <date-picker v-model="dateTo" :config="pickerConfig2"></date-picker>
    </div>
    <button class="btn btn-primary" @click.prevent="getData()">{{$options.filters.translate('Generate', lang)}}</button>
  </form>
  <!-- <p v-if="formattedDataByRestaurants"> <pre>{{ formattedDataByRestaurants }} </pre></p> -->
  <br />
  <br />
  <div v-if="formattedDataByAreaAndObjects">
    <div v-for="(area, key) in formattedDataByAreaAndObjects" :key="key" :class="classify(key)">
      <div>{{ key }} ({{ area.totalFailures }}):</div>
      <ErrorBar
        @acivateErrorsDetailsModal="acivateErrorsDetailsModal"
        :area="area"
        :maxFailuresInArea="maxFailuresInArea"
        :checkedRestaurants="checkedRestaurants"
        :dateFrom="dateFrom"
        :dateTo="dateTo">
      </ErrorBar>

      <br />
      <br />
      <div>
        <span v-if="key2 !== 'totalFailures'" v-for="(object, key2) in area" :key="key2">
          <span :class="classify(key2)">{{ key2 }} &nbsp; </span>
        </span>
      </div>
      <hr />
    </div>
  </div>
</div>

</template>
<script>
import ErrorBar from '@/components/reports/ErrorBar'
import ErrorDetailsModal from '@/components/reports/ErrorDetailsModal'

export default {
  name: 'errorsList',
  props: ['lang'],
  created () {
    // this.getErrors()
  },
  data () {
    return {
      pickerConfig: {format: 'YYYY-MM-DD', maxDate: this.$moment().subtract(1, 'days').format('YYYY-MM-DD'), minDate: false},
      pickerConfig2: {format: 'YYYY-MM-DD', maxDate: this.$moment().format('YYYY-MM-DD'), minDate: false},
      dataFromSql: undefined,
      // dateFrom: this.$moment('2018-09-15').format('YYYY-MM-DD'),
      dateFrom: this.$moment().subtract(1, 'days').format('YYYY-MM-DD'),
      dateTo: this.$moment().format('YYYY-MM-DD'),
      formattedDataByAreaAndObjects: undefined,
      checkedRestaurants: [],
      maxFailuresInArea: 0,
      errorsDetailsModalData: undefined
    }
  },
  components: {
    ErrorBar,
    ErrorDetailsModal
  },
  watch: {
  },
  methods: {
    uncheck () {
      this.checkedRestaurants = []
    },
    errorDetailsModalClose () {
      this.errorsDetailsModalData = undefined
    },
    acivateErrorsDetailsModal (params) {
      if (process.env.NODE_ENV !== 'production') {
        console.log(params)
      }
      this.getDetails(params)
    },
    classify (string) {
      return string.replace(/[\W_]+/g, '-').toLowerCase()
    },
    getDetails (params) {
      this.$http.post('report/networkerrormatrixerrordetails', params)
        .then(response => {
          return response.json()
        })
        .then(data => {
          this.errorsDetailsModalData = data
        })
    },
    getData () {
      this.formattedDataByAreaAndObjects = undefined
      this.maxFailuresInArea = 0
      this.dataFromSql = undefined
      let self = this
      this.$http.post('report/networkerrormatrixerror', { dateFrom: this.dateFrom, dateTo: this.dateTo })
        .then(response => {
          return response.json()
        })
        .then(data => {
          this.dataFromSql = data
          self.formatDataByAreasAndObjects()
        })
    },
    __calculateTotalFailures (data) {
      if (process.env.NODE_ENV !== 'production') {
        console.log(data)
      }
      for (const area of Object.keys(data)) {
        let totalFailuresInArea = 0
        for (const object of Object.keys(data[area])) {
          var totalFailuresInAreaAndObject = data[area][object].reduce(function (prev, cur) {
            return prev + cur.failures
          }, 0)
          data[area][object].totalFailures = totalFailuresInAreaAndObject
          totalFailuresInArea += totalFailuresInAreaAndObject
        }
        if (this.maxFailuresInArea < totalFailuresInArea) this.maxFailuresInArea = totalFailuresInArea
        data[area].totalFailures = totalFailuresInArea
      }
      return data
    },

    formattedDataByRestaurants () {
      if (!this.data) return false
      if (!this.restaurants) return false
      let returnData = []
      for (let index = 0; index < this.restaurants.length; index++) {
        returnData.push({ restaurant: this.restaurants[index], errors: [] })
      }
      for (let index = 0; index < this.data.length; index++) {
        let indexforRow = returnData.findIndex(entry => entry.restaurant === this.data[index].restaurant)
        returnData[indexforRow].errors.push(this.data[index])
      }
      return returnData
    },
    formatDataByAreasAndObjects () {
      if (!this.data) return false
      let returnData = {}
      let areas = [...new Set(this.data.map(row => row.area))]
      for (let index = 0; index < areas.length; index++) {
        returnData[areas[index]] = {}
        const dataInArea = this.data.filter(row => row.area === areas[index])
        const objects = [...new Set(dataInArea.map(row => row.object))]
        for (let index2 = 0; index2 < objects.length; index2++) {
          const dataInAreaAndObjects = dataInArea.filter(row => row.object === objects[index2])
          returnData[areas[index]][objects[index2]] = dataInAreaAndObjects
        }
      }
      let result = this.__calculateTotalFailures(returnData)
      this.formattedDataByAreaAndObjects = result
      // return result
    }
  },
  computed: {
    data () {
      if (this.checkedRestaurants.length === 0) {
        console.info('dataFromSql', this.checkedRestaurants)
        return this.dataFromSql
      } else {
        let returnArray = []
        console.error('data', this.checkedRestaurants)
        for (let index = 0; index < this.dataFromSql.length; index++) {
          if (this.checkedRestaurants.indexOf(this.dataFromSql[index].restaurant) > -1) {
            returnArray.push(this.dataFromSql[index])
          }
        }
        return returnArray
      }
    },
    restaurants () {
      if (!this.dataFromSql) return false
      let restaurants = [...new Set(this.dataFromSql.map(row => row.restaurant))].sort()
      // this.checkedRestaurants = JSON.parse(JSON.stringify(restaurants))
      return restaurants
    }
  }
}
</script>
<style lang="sass" scoped>
@import "~sass/_variables.scss"
.checkbox
  margin-right: 12px
.kioskapi-application
  color: #ff0000
.kioskfrontend
  color: #aa0000
.printer
  color: #0000b0
.terminal
  color: #3333b0
.ethernet
  color: #00b000
.kiosk-controller
  color: #33b033
.database
  color: #ffb000
.sm-width
  width: 50px
  white-space: nowrap

table
  overflow-y: scroll
  max-height: 370px

  td
    cursor: pointer

  .level1
    background-color: $brand-danger

  .level2
    background-color: $brand-warning

  .level3
    background-color: $brand-info

  .level-
    background-color: none
</style>



// WEBPACK FOOTER //
// src/components/reports/Errors.vue